import { useAccount, useMsal } from '@azure/msal-react';
import { CogniteClient } from '@cognite/sdk';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { CogniteClientContext } from './CogniteClientContext';
import { LabeledLoader } from '#components/layout/LabeledLoader';
import { env } from '#lib/env';

export function CogniteClientProvider({ children }: React.PropsWithChildren) {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts.find((account) => account.tenantId === tenantId) ?? {});
  useEffect(() => {
    async function checkActiveAccount() {
      if (!account) {
        instance.setActiveAccount(null);
        await instance.acquireTokenRedirect(request);
      }
    }
    void checkActiveAccount();
  }, [instance, account]);

  const { data: authenticatedClient } = useQuery({
    queryKey: ['cogniteAuth', account] as const,
    queryFn: async ({ queryKey: [, account] }) => {
      if (!account) {
        return null;
      }

      const client = new CogniteClient({
        appId: clientId,
        baseUrl: env.cdf.url ?? baseUrl,
        project,
        async oidcTokenProvider() {
          const { accessToken } = await instance.acquireTokenSilent({
            ...request,
            account,
          });

          return accessToken;
        },
      });
      await client.authenticate();
      return client;
    },
  });

  if (!authenticatedClient) {
    return <LabeledLoader label="Authenticating..." />;
  }

  return <CogniteClientContext value={authenticatedClient}>{children}</CogniteClientContext>;
}

// TODO: move to schema/env.ts
const { cluster, clientId, project, tenantId } = env.auth;
const baseUrl = `https://${cluster}.cognitedata.com`;
const scopes: string[] = [`${baseUrl}/.default`];
const request = { scopes };
